module.exports = __webpack_public_path__ + "static/media/BudgetSmart-Icon.a17d1651.svg";